import { render, staticRenderFns } from "./CheckoutInformation.vue?vue&type=template&id=c52bdbf4&"
import script from "./CheckoutInformation.vue?vue&type=script&lang=ts&"
export * from "./CheckoutInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Buildserver\\Agent01\\_work\\1030\\s\\JCD.Retail.Webshop\\App\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c52bdbf4')) {
      api.createRecord('c52bdbf4', component.options)
    } else {
      api.reload('c52bdbf4', component.options)
    }
    module.hot.accept("./CheckoutInformation.vue?vue&type=template&id=c52bdbf4&", function () {
      api.rerender('c52bdbf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/webshop/pages/checkout/CheckoutInformation.vue"
export default component.exports